import React from 'react';
import DatePicker from 'react-datepicker';

export default class DatePickerForForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }
    
    render() {
        const form = this.props.form;
        const fieldName = this.props.fieldName;

        return <div className={`react-datepicker-block ${form.err(fieldName) ? "react-date-invalid" : ""}`}>
            <DatePicker
                className={`form-control ${form.err(fieldName) ? "is-invalid" : ""}`}
                onChange={value => {
                    form.vals({ [fieldName]: value });
                }}
                selected={form.val(fieldName) ? new Date(form.val(fieldName)) : null}
                maxDate={new Date()}
                readOnly={form.isFieldDisabled(fieldName)}
                showTimeSelect
                timeIntervals={15}
                filterTime={(time) => {
                    const currentDate = new Date();
                    const selectedDate = new Date(time);
                    return currentDate.getTime() >= selectedDate.getTime();
                }}
                dateFormat={"dd/MM/yyyy h:mm aa"}
                timeCaption="Time"
                open={!form.isFieldDisabled(fieldName) && this.state.datePickerOpen}
                onInputClick={() => { this.setState({ datePickerOpen: true }); }}
                onClickOutside={() => { this.setState({ datePickerOpen: false }); }}
            />
            <div className="invalid-feedback">
                {form.err(fieldName)}
            </div>
        </div>
    }
}